import { render } from "./ArticleSmallBox.vue?vue&type=template&id=c754aaea&scoped=true"
import script from "./ArticleSmallBox.vue?vue&type=script&lang=js"
export * from "./ArticleSmallBox.vue?vue&type=script&lang=js"

import "./ArticleSmallBox.vue?vue&type=style&index=0&id=c754aaea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c754aaea"

export default script